import { mapActions, mapMutations } from 'vuex'

import { cpf } from 'cpf-cnpj-validator'
import { strip as cnpjStrip } from '@/utils/validators/cnpj'

import { StatusAgendamento } from '@/utils/agendamento'

export const methods = {
  ...mapActions('fornecedores', ['getFornecedores']),
  ...mapActions('clientes', ['getClientes']),
  ...mapActions('transportadoras', ['getTransportadoras']),
  ...mapActions('contratos', ['getContratos']),
  ...mapActions('patio', [
    'getRegioes',
    'getRepresentantes',
    'getTipoOperacao',
    'getServicos',
  ]),
  ...mapActions('motoristas', ['getMotoristas']),
  ...mapMutations('relatorioCargaDescarga', ['UPDATE_PARAMS']),
  handleFixParams(fixedParams, [key, param]) {
    if (param.value) {
      const paramsWithCNPJ = []
      const paramsWithCPF = ['representante', 'motorista']
      const paramsWithPublicId = ['fornecedor', 'cliente']
      const paramsProdutoWithId = ['produto']
      const paramsSubProdutoWithId = ['sub_produto']

      if (param.until == true) {
        if (param.value.trim().split(' ').length == 1) {
          param.value += ' 23:59:59'
        } else if (param.value.trim().split(' ')[1].split(':').length == 2) {
          param.value += ':59'
        }
      }
      if (paramsWithCNPJ.includes(key)) {
        fixedParams[key] = cnpjStrip(param.value)
      } else if (paramsWithCPF.includes(key)) {
        fixedParams[key] = cpf.strip(param.value)
      } else if (paramsWithPublicId.includes(key)) {
        if (key === 'fornecedor') {
          fixedParams[key] = this.params.fornecedor.value.fornecedor_id
        } else {
          if (key === 'cliente') {
            if (Array.isArray(this.params.cliente.value)) {
              fixedParams[key] = this.params.cliente.value
                .map((c) => c.cliente_id)
                .join(',')
            } else {
              fixedParams[key] = this.params.cliente.value.cliente_id
            }
          } else {
            fixedParams[key] = param.value
          }
        }
      } else if (paramsProdutoWithId.includes(key)) {
        if (Array.isArray(this.params.produto.value)) {
          fixedParams[key] = this.params.produto.value
            .map((p) => p.id)
            .join(',')
        } else {
          fixedParams[key] = this.params.produto.value.id
        }
      } else if (paramsSubProdutoWithId.includes(key)) {
        if (Array.isArray(this.params.sub_produto.value)) {
          fixedParams[key] = this.params.sub_produto.value
            .map((p) => p.id)
            .join(',')
        } else {
          fixedParams[key] = this.params.sub_produto.value.id
        }
      } else {
        fixedParams[key] = param.value
      }
    }

    return fixedParams
  },
  fixParams() {
    return Object.entries(this.params).reduce(
      this.handleFixParams,
      new Object()
    )
  },

  addParamsFilter() {
    localStorage.setItem(
      'filterOptionsDetailsRelatorioCargaDescarga',
      JSON.stringify(this.params)
    )
  },

  getParamsFilter() {
    if (localStorage.getItem('filterOptionsDetailsRelatorioCargaDescarga')) {
      const params_local = JSON.parse(
        localStorage.getItem('filterOptionsDetailsRelatorioCargaDescarga')
      )
      Object.entries(params_local).forEach((item) => {
        if (item[0] in this.params)
          this.params[item[0]] = { ...this.params[item[0]], ...item[1] }
      })
    }
  },

  search() {
    if (!this.areSettingsEmpty) {
      const fixedParams = {
        ...this.fixParams(),
        status: StatusAgendamento.CONCLUIDO,
      }

      if (this.servico) {
        fixedParams.servico = this.servico
      }
      this.addParamsFilter()
      this.UPDATE_PARAMS(fixedParams)
      this.$emit('search')
    }
  },

  async showOnlySelectedOptionsAndGetItems() {
    if (localStorage.getItem('filterOptionsDetailsRelatorioCargaDescarga')) {
      const params_local = JSON.parse(
        localStorage.getItem('filterOptionsDetailsRelatorioCargaDescarga')
      )
      Object.entries(params_local).forEach((item) => {
        if (item[0] in this.params)
          this.params[item[0]] = { ...this.params[item[0]], ...item[1] }
      })
    }
    this.allOptions.forEach((someOption) => {
      if (this.params[someOption]) {
        this.params[someOption].visible = false
      } else {
        console.log(someOption + ' não encontrada!')
      }
    })
    this.selectedOptions.forEach((option) => {
      if (this.params[option]) {
        this.params[option].visible = true
      } else {
        console.log(option + ' não encontrada!')
      }
      //this.params[option].visible = true
    })
    this.allOptions.forEach((someOption) => {
      if (this.params[someOption]?.visible == false) {
        this.params[someOption].value = ''
      }
    })
    this.addParamsFilter()
    this.showDaddy()
  },

  showDaddy() {
    for (let [daddy, dependents] of Object.entries(this.dependents)) {
      const isSomeDependentVisible = dependents.some(
        (dependent) => this.params[dependent].visible
      )
      if (isSomeDependentVisible) {
        this.params[daddy].visible = true
      }
    }
  },

  async getCustomTransbordoDownload() {
    const params = {
      ...this.getDefaultParams(),
    }
    try {
      await this.$emit('customTransbordoDownload', params)
    } catch (error) {
      console.error('Error in getCustomTransbordoDownload:', error)
    }
  },
  async gateSelected(gate) {
    this.gate.servicos = []
    let servicos = []

    if (gate == this.empresaAtual.public_id) {
      servicos = await this.getServicos({
        proprietario: this.gate.public_id,
      })
    } else {
      const fornecedores = await this.getFornecedores(this.gate)
      const fornecedor = fornecedores.find(
        (i) => i.fornecedor_id == this.empresaAtual.public_id
      )
      if (fornecedor) {
        servicos = fornecedor.servicos_autorizados.map((i) => i.servico)
      }
    }
    this.servicos = servicos
  },
}
